import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { AdminBillingPanel } from '@/components/admin/AdminBillingPanel';

/** Standalone admin billing page (also embedded in Admin Dashboard). */
export function AdminBillingRatesPage() {
  return (
    <div className="pt-6">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/admin"
          className="inline-flex items-center gap-1 text-slate-500 hover:text-indigo-600 text-sm mb-4"
        >
          <ChevronLeft className="w-4 h-4" />
          Admin dashboard
        </Link>
      </div>
      <AdminBillingPanel />
    </div>
  );
}
